<!-- ── Main Dialog (select_type | select_subtype | select_datetime) ── -->
@if (currentStep() === 'select_type' || currentStep() === 'select_subtype' || currentStep() === 'select_datetime') {
  <p-dialog
    [visible]="true"
    [modal]="true"
    [style]="{ width: '869px', maxWidth: '95vw', margin: '1rem' }"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [appendTo]="'body'"
    [showHeader]="false"
    styleClass="frontdesk-main-dialog"
  >
    <div class="pl-[45px] pr-[31px] pt-[36px] pb-[70px] relative max-h-[85vh] overflow-y-auto overflow-x-hidden max-md:pb-5">

      <!-- Header -->
      <div class="flex items-start mb-[10px] gap-2">
        <button type="button" (click)="onBack()"
          class="bg-transparent cursor-pointer flex items-center justify-center p-1 rounded-[6px] flex-shrink-0 w-8 h-8 mt-0.5 transition-colors hover:bg-slate-100 border-0">
          <img src="assets/icons/backward-arrow.svg" alt="Back" class="w-8 h-8" />
        </button>
        <h2 class="text-[28px] font-bold text-[#192A3E] flex-1 text-left leading-tight break-words">
          @if (currentStep() === 'select_type') { Please Select Type }
          @else if (currentStep() === 'select_subtype') { Select Instructions }
          @else if (currentStep() === 'select_datetime') { Select Date &amp; Time }
        </h2>
        <button type="button" (click)="onClose()"
          class="bg-transparent cursor-pointer flex items-center justify-center p-1 rounded-[6px] flex-shrink-0 w-10 h-10 mt-0.5 transition-colors hover:bg-slate-100 border-0">
          <img src="assets/icons/dialog-cancel.svg" alt="close" class="w-10 h-10" />
        </button>
      </div>

      <!-- ════ Step 1: Select Type ════ -->
      @if (currentStep() === 'select_type') {
        <div class="mt-[10px]">
          <p class="text-[20px] font-bold text-[#192A3E] mb-[14px] max-[480px]:text-base">Front Desk</p>
          <div class="grid grid-cols-2 gap-[14px] max-[560px]:grid-cols-1 max-[560px]:gap-[10px]">
            @for (cat of categories; track cat.value) {
              <button type="button"
                class="group flex items-center px-[16px] py-[20px] w-full h-[95px] rounded-[10px] border-[1.5px] bg-white border-[#EBEFF2] cursor-pointer transition-[border-color,background] duration-150 text-left gap-[14px] hover:bg-[#2E7FBE] hover:border-[#2E7FBE] data-[active=true]:bg-[#2E7FBE] data-[active=true]:border-[#2E7FBE]"
                [attr.data-active]="selectedCategory()?.value === cat.value ? true : null"
                (click)="selectCategory(cat)">
                <div class="w-[55px] h-[55px] min-w-[55px] rounded-[5px] flex items-center justify-center bg-[#F2F6F8] flex-shrink-0 overflow-hidden">
                  <img [src]="cat.image" [alt]="cat.label" class="w-full h-full object-cover" />
                </div>
                <div class="flex-1 flex flex-col gap-[3px] min-w-0">
                  <div class="text-[18px] font-semibold text-[#192A3E] leading-tight group-hover:text-white group-data-[active=true]:text-white">{{ cat.label }}</div>
                  <div class="text-[13px] text-[#4E4D4D] group-hover:text-white group-data-[active=true]:text-white leading-[1.4] line-clamp-2">{{ cat.description }}</div>
                </div>
              </button>
            }
          </div>
        </div>
      }

      <!-- ════ Step 2: Select Instructions ════ -->
      @if (currentStep() === 'select_subtype') {
        <div class="mt-[10px]">
          <p class="text-[20px] font-bold text-[#192A3E] mb-[14px] max-[480px]:text-base">Instructions</p>
          <div class="grid grid-cols-2 gap-[14px] max-[560px]:grid-cols-1 max-[560px]:gap-[10px]">
            @for (sub of instructionSubtypes; track sub.value) {
              <button type="button"
                class="group flex items-center px-[16px] py-[20px] w-full h-[95px] rounded-[10px] border-[1.5px] bg-white border-[#EBEFF2] cursor-pointer transition-[border-color,background] duration-150 text-left gap-[14px] hover:bg-[#2E7FBE] hover:border-[#2E7FBE] data-[active=true]:bg-[#2E7FBE] data-[active=true]:border-[#2E7FBE]"
                [attr.data-active]="selectedSubType()?.value === sub.value ? true : null"
                (click)="selectSubType(sub)">
                <div class="flex-1 flex flex-col gap-[3px] min-w-0">
                  <div class="text-[18px] font-semibold text-[#192A3E] leading-tight group-hover:text-white group-data-[active=true]:text-white">{{ sub.label }}</div>
                  <div class="text-[13px] text-[#4E4D4D] group-hover:text-white group-data-[active=true]:text-white leading-[1.4] line-clamp-2">{{ sub.description }}</div>
                </div>
              </button>
            }
          </div>
        </div>
      }

      <!-- ════ Step 3: Date & Time ════ -->
      @if (currentStep() === 'select_datetime') {
        <div class="mt-[70px] mb-[80px] min-[640px]:mt-[114px] min-[640px]:mb-[80px]">
          <div class="flex gap-5 justify-center max-[639px]:flex-col max-[639px]:gap-[26px]">

            <!-- Date -->
            <div class="flex items-center gap-3 min-[640px]:w-[338px] relative">
              <div class="flex-1 border-2 border-[#D9DDE0] rounded-[5px] h-[63px] flex items-center justify-between bg-white pl-[38px]">
                <span class="text-base min-[640px]:text-[20px] text-[#232F40] font-semibold">
                  {{ getFormattedDate() }} &bull; {{ getDayOfWeek() }}
                </span>
                <button type="button" (click)="openDatePicker(dateInput)"
                  class="text-[#238EC6] border-2 border-[#D9DDE0] absolute right-0 bg-[#E8EDF0] w-[53px] flex items-center justify-center h-[63px] rounded-tr-[5px] rounded-br-[5px]">
                  <img src="assets/icons/calendar_3.svg" alt="calendar" class="w-[34px] h-[34px]" />
                </button>
                <input #dateInput type="date" [value]="selectedDate()"
                  class="absolute opacity-0 pointer-events-none w-0 h-0" (change)="onDateChange($event)" />
              </div>
            </div>

            <div class="flex items-center gap-[18px] min-[640px]:gap-3">
              <!-- Hour Dropdown -->
              <div class="time-dropdown-wrap border-2 w-1/2 border-[#D9DDE0] rounded-[5px] px-2 min-[414px]:px-4 py-3 h-[63px] flex items-center bg-white min-[640px]:min-w-[188px] relative cursor-pointer"
                (click)="toggleHourDropdown($event)">
                <img src="assets/icons/clock-icon.svg" alt="time" class="w-5 h-5 min-[414px]:w-[34px] min-[414px]:h-[34px] flex-shrink-0 mr-[10px]" />
                <span class="text-base min-[414px]:text-[20px] text-[#232f40] font-semibold">{{ getHourLabel() }}</span>
                @if (showHourDropdown()) {
                  <div class="time-dropdown fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[160px] h-[571px] max-h-[85vh] z-[100001] bg-white border-2 border-[#D9DDE0] rounded-[5px] shadow-[0_10px_40px_rgba(0,0,0,0.25)] flex flex-col overflow-y-auto"
                    (click)="$event.stopPropagation()">
                    @for (hour of hoursList; track $index) {
                      <div class="w-full text-center py-[18px] text-[20px] font-semibold text-[#232F40] cursor-pointer transition-colors hover:bg-[#F2F6F8]"
                        [class.bg-[#F2F6F8]]="selectedHour() === hour.value"
                        (click)="selectHour($index); $event.stopPropagation()">
                        {{ hour.title }}
                      </div>
                    }
                  </div>
                }
              </div>

              <!-- Minute Dropdown -->
              <div class="time-dropdown-wrap border-2 w-1/2 border-[#D9DDE0] rounded-[5px] px-2 min-[414px]:px-4 py-3 h-[63px] flex items-center bg-white min-[640px]:min-w-[143px] relative cursor-pointer"
                (click)="toggleMinuteDropdown($event)">
                <img src="assets/icons/clock-icon.svg" alt="duration" class="w-5 h-5 min-[414px]:w-[34px] min-[414px]:h-[34px] flex-shrink-0 mr-[10px]" />
                <span class="text-base min-[414px]:text-[20px] text-[#232f40] font-semibold">:{{ selectedMinute() }}</span>
                @if (showMinuteDropdown()) {
                  <div class="time-dropdown fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[160px] h-[571px] max-h-[85vh] z-[100001] bg-white border-2 border-[#D9DDE0] rounded-[5px] shadow-[0_10px_40px_rgba(0,0,0,0.25)] flex flex-col overflow-y-auto"
                    (click)="$event.stopPropagation()">
                    @for (min of minutesList; track $index) {
                      <div class="w-full text-center py-[18px] text-[20px] font-semibold text-[#232F40] cursor-pointer transition-colors hover:bg-[#F2F6F8]"
                        [class.bg-\[\#F2F6F8\]]="selectedMinute() === min"
                        (click)="selectMinute($index); $event.stopPropagation()">
                        :{{ min }}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>

          <!-- Next button -->
          <div class="flex justify-end w-full absolute bottom-0 right-0 py-5 pr-[34px] min-[640px]:pr-10 bg-white border-t border-[#EBEFF2] rounded-bl-[10px] rounded-br-[10px]">
            <button type="button" (click)="onDateTimeNext()"
              class="text-white w-[117px] py-1 rounded-[5px] bg-[#238EC6] text-[16px] font-semibold hover:bg-[#238EC6]/80 transition">
              Next
            </button>
          </div>
        </div>
      }

    </div>
  </p-dialog>
}

<!-- ── Review Dialog (Step 4) ── -->
@if (currentStep() === 'review_details') {
  <p-dialog
    [visible]="true"
    [modal]="true"
    [style]="{ width: '532px', maxWidth: '95vw', margin: '1rem' }"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [appendTo]="'body'"
    styleClass="frontdesk-review-dialog"
  >
    <ng-template #header>
      <div class="w-full flex items-center gap-2 mb-3">
        <button type="button" (click)="onBack()"
          class="bg-transparent cursor-pointer flex items-center justify-center p-1 rounded-[6px] flex-shrink-0 w-8 h-8 mt-0.5 transition-colors hover:bg-slate-100 border-0">
          <img src="assets/icons/backward-arrow.svg" alt="Back" class="w-8 h-8" />
        </button>
        <h2 class="text-[28px] font-bold text-[#192A3E] flex-1 text-left leading-tight">Review Details</h2>
        <button type="button" (click)="onClose()"
          class="bg-transparent cursor-pointer flex items-center justify-center p-1 rounded-[6px] flex-shrink-0 w-10 h-10 mt-0.5 transition-colors hover:bg-slate-100 border-0">
          <img src="assets/icons/dialog-cancel.svg" alt="close" class="w-10 h-10" />
        </button>
      </div>
    </ng-template>

    <div class="flex flex-col gap-3 mb-[55px]">

      <!-- User + sub type row -->
      <div class="flex items-center gap-[10px]">
        <div class="relative w-[50px] h-[50px] rounded-full overflow-hidden flex-shrink-0">
          <img [src]="getUserAvatar()" alt="avatar"
            [class.blur-sm]="isPictureBlocked(currentUser?.profile_picture_moderation_status)"
            class="w-full h-full object-cover" />
          @if (isPictureBlocked(currentUser?.profile_picture_moderation_status)) {
          <img src="assets/icons/eye-icon-white.png" alt="Under review" class="absolute inset-0 m-auto w-5 h-5 pointer-events-none" />
          }
        </div>
        <p class="text-[20px] text-[#2F3A48] flex-1 m-0">
          <strong>{{ getUserFullName() }}</strong> {{ mode() === 'edit' ? 'updated' : 'requested' }}
          <strong>{{ selectedSubType()?.label }}</strong>
          <button type="button" (click)="currentStep.set('select_subtype')" aria-label="Edit sub type"
            class="bg-transparent border-0 cursor-pointer p-[2px_4px] inline-flex items-center align-middle ml-0.5">
            <img src="assets/icons/pencil.svg" alt="edit" />
          </button>
        </p>
      </div>

      <!-- Chips row -->
      <div class="flex items-center gap-2 flex-wrap">

        <!-- Category chip -->
        <button type="button"
          class="flex items-center gap-2 text-sm font-semibold px-3 py-[5px] rounded-full bg-[#192A3E] text-white border border-[#192A3E] hover:opacity-90 transition"
          (click)="currentStep.set('select_type')">
          {{ selectedCategory()?.label }}
          <img src="assets/icons/dropdown-arrow.svg" alt="arrow" class="w-2.5 h-2.5 brightness-0 invert" />
        </button>

        <!-- Assign Management chip -->
        <button type="button"
         class="flex items-center gap-2 text-sm font-semibold px-3 py-[5px] rounded-full hover:opacity-90 transition border"
            [class.bg-[#192A3E]]="selectedManagement()"
            [class.text-white]="selectedManagement()"
            [class.border-[#192A3E]]="selectedManagement()"
            [class.bg-white]="!selectedManagement()"
            [class.text-[#192A3E]]="!selectedManagement()"
            [class.border-[#D9DDE2]]="!selectedManagement()"
          (click)="openAssign('management', 'Assign Management')">
          <div class="relative w-6 h-6 rounded-full bg-[#2E7FBE] flex-shrink-0 flex items-center justify-center overflow-hidden"
            [class.opacity-50]="!selectedManagement()">
            @if (getAssigneeAvatar(selectedManagement()); as avatar) {
              <img [src]="avatar" alt=""
                [class.blur-sm]="isPictureBlocked(selectedManagement()?.profile_picture_moderation_status)"
                class="w-full h-full object-cover" />
              @if (isPictureBlocked(selectedManagement()?.profile_picture_moderation_status)) {
              <img src="assets/icons/eye-icon-white.png" alt="Under review" class="absolute inset-0 m-auto w-3 h-3 pointer-events-none" />
              }
            } @else {
              <img src="assets/images/dummy-avatar.jpg" alt="" class="w-full h-full object-cover" />
            }
          </div>
          {{ selectedManagement() ? getAssigneeName(selectedManagement()) : 'Assign Management' }}
          <img src="assets/icons/dropdown-arrow.svg" alt="arrow" class="w-2.5 h-2.5"
            [class.brightness-0]="selectedManagement()" [class.invert]="selectedManagement()" />
        </button>

        <!-- Assign Front Desk chip -->
        <button type="button"
         class="flex items-center gap-2 text-sm font-semibold px-3 py-[5px] rounded-full hover:opacity-90 transition border"
            [class.bg-[#192A3E]]="selectedFrontDesk()"
            [class.text-white]="selectedFrontDesk()"
            [class.border-[#192A3E]]="selectedFrontDesk()"
            [class.bg-white]="!selectedFrontDesk()"
            [class.text-[#192A3E]]="!selectedFrontDesk()"
            [class.border-[#D9DDE2]]="!selectedFrontDesk()"
          (click)="openAssign('front_desk', 'Assign Front Desk')">
          <div class="relative w-6 h-6 rounded-full bg-[#2E7FBE] flex-shrink-0 flex items-center justify-center overflow-hidden"
            [class.opacity-50]="!selectedFrontDesk()">
            @if (getAssigneeAvatar(selectedFrontDesk()); as avatar) {
              <img [src]="avatar" alt=""
                [class.blur-sm]="isPictureBlocked(selectedFrontDesk()?.profile_picture_moderation_status)"
                class="w-full h-full object-cover" />
              @if (isPictureBlocked(selectedFrontDesk()?.profile_picture_moderation_status)) {
              <img src="assets/icons/eye-icon-white.png" alt="Under review" class="absolute inset-0 m-auto w-3 h-3 pointer-events-none" />
              }
            } @else {
              <img src="assets/images/dummy-avatar.jpg" alt="" class="w-full h-full object-cover" />
            }
          </div>
          {{ selectedFrontDesk() ? getAssigneeName(selectedFrontDesk()) : 'Assign Front Desk' }}
          <img src="assets/icons/dropdown-arrow.svg" alt="arrow" class="w-2.5 h-2.5"
            [class.brightness-0]="selectedFrontDesk()" [class.invert]="selectedFrontDesk()" />
        </button>

      </div>

      <!-- Date pill -->
      <button type="button"
        class="flex items-center gap-2 text-sm font-semibold px-3 py-[5px] rounded-full bg-[#192A3E] text-white border border-[#192A3E] hover:opacity-90 transition self-start"
        (click)="currentStep.set('select_datetime')">
        <img src="assets/icons/calendar_2.png" alt="cal" class="w-[18px] h-[18px] brightness-0 invert flex-shrink-0" />
        <span>Set on: {{ getPickupDateTimeLabel() }}</span>
        <img src="assets/icons/dropdown-arrow.svg" alt="arrow" class="w-2.5 h-2.5 brightness-0 invert flex-shrink-0" />
      </button>

      <hr class="my-1" />

      <!-- Title card -->
      <div class="bg-[#F2F6F8] rounded-[10px] px-4 py-3 flex items-center gap-2">
        <input type="text" placeholder="Title"
          [value]="title()"
          (input)="title.set($any($event.target).value)"
          class="flex-1 bg-transparent border-none outline-none text-base text-[#192A3E] font-semibold " />
        <button type="button" (click)="openSuggestion('title')"
          [disabled]="isAiGenerating()"
          class="flex-shrink-0 text-[12px] font-semibold text-[#192A3E] bg-white border border-[#EBEFF2] rounded-full px-3 py-1 cursor-pointer hover:bg-white/80 transition whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed">
          @if (isAiGenerating() && aiTargetField() === 'title') {
            Generating...
          } @else {
            Use AI ✦
          }
        </button>
      </div>

      <!-- Description card -->
      <div class="bg-[#F2F6F8] rounded-[10px] px-4 py-3 flex flex-col gap-2">
        <textarea rows="4" placeholder="Description"
          [value]="description()"
          (input)="description.set($any($event.target).value)"
          class="w-full bg-transparent border-none outline-none text-base text-[#192A3E] font-semibold  resize-none"></textarea>
        <div class="flex justify-end">
          <button type="button" (click)="openSuggestion('desc')"
            [disabled]="isAiGenerating()"
            class="text-[12px] font-semibold text-[#192A3E] bg-white border border-[#EBEFF2] rounded-full px-3 py-1 cursor-pointer hover:bg-white/80 transition whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed">
            @if (isAiGenerating() && aiTargetField() === 'desc') {
              Generating...
            } @else {
              Use AI to generate description ✦
            }
          </button>
        </div>
      </div>

      <!-- AI Suggestion box -->
      @if (showSuggestion()) {
        <div class="bg-white border border-[#E6E9EF] rounded-[10px] shadow-lg p-4">
          <p class="text-[18px] font-semibold mb-2 text-[#192A3E]">Suggested</p>
          @if (suggestedAiContent().length) {
            <p class="text-[14px] text-[#4E4D4D] leading-[22px] min-h-[50px] max-h-[85px] overflow-y-auto">
              {{ suggestedAiContent() }}
            </p>
          } @else {
            <div class="flex items-center justify-center min-h-[50px]">
              <img src="assets/icons/loader.gif" class="w-[40px] h-[40px]" alt="loading" />
            </div>
          }
          <div class="flex justify-end gap-3 mt-4">
            <button type="button"
              class="text-sm text-[#6B7280] px-4 py-1.5 rounded-full border border-[#EBEFF2] hover:bg-gray-50"
              (click)="closeSuggestion()">
              Dismiss
            </button>
            @if (suggestedAiContent().length) {
              <button type="button"
                class="text-sm px-4 py-1.5 rounded-full bg-[#238EC6] text-white hover:bg-[#1d7ab0]"
                (click)="useSuggestion()">
                Use
              </button>
            }
          </div>
        </div>
      }

      <!-- Request Details card -->
      <div class="bg-white border border-[#EBEFF2] rounded-[10px] p-4 mb-[55px]">
        <div class="flex items-center justify-between mb-3">
          <span class="text-[22px] font-semibold text-[#192A3E]">Request Details</span>
          <!-- <button type="button" class="p-1">
            <img src="assets/icons/dialog-cancel.svg" alt="add" class="w-[22px] h-[22px] rotate-45" />
          </button> -->
        </div>
        <div class="border-t border-[#E4E6E8] mb-0"></div>

        <!-- Full Name -->
        <div class="border-b border-[#E4E6E8] py-3">
          <p class="text-base text-[#238EC6] font-semibold mb-1">Full Name</p>
          <input type="text" placeholder="Full Name"
            [value]="fullName()"
            [disabled]="mode() === 'edit'"
            (input)="fullName.set($any($event.target).value)"
            class="w-full bg-transparent border-none outline-none text-base text-[#192A3E] font-semibold placeholder:text-[#A0A7B0] disabled:opacity-70 disabled:cursor-not-allowed" />
        </div>

        <!-- Email -->
        <div class="border-b border-[#E4E6E8] py-3">
          <p class="text-base text-[#238EC6] font-semibold mb-1">Contact Info: Email</p>
          <input type="email" placeholder="Email"
            [value]="email()"
            [disabled]="mode() === 'edit'"
            (input)="email.set($any($event.target).value)"
            class="w-full bg-transparent border-none outline-none text-base text-[#192A3E] font-semibold placeholder:text-[#A0A7B0] disabled:opacity-70 disabled:cursor-not-allowed" />
        </div>

        <!-- Work Number -->
        <div class="border-b border-[#E4E6E8] py-3">
          <p class="text-base text-[#238EC6] font-semibold mb-1">Contact Info: Work Number</p>
          <div class="flex items-center gap-2">
            <span class="text-base flex-shrink-0">🇺🇸</span>
            <input type="tel" placeholder="Phone number"
              [value]="workNumber()"
              [disabled]="mode() === 'edit'"
              (input)="workNumber.set($any($event.target).value)"
              class="flex-1 bg-transparent border-none outline-none text-base text-[#192A3E] font-semibold placeholder:text-[#A0A7B0] disabled:opacity-70 disabled:cursor-not-allowed" />
          </div>
        </div>

        <!-- Address -->
        <div class=" py-3">
          <p class="text-base text-[#238EC6] font-semibold mb-1">Enter Address</p>
          <input type="text" placeholder="Address"
            [value]="address()"
            [disabled]="mode() === 'edit'"
            (input)="address.set($any($event.target).value)"
            class="w-full bg-transparent border-none outline-none text-base text-[#192A3E] font-semibold placeholder:text-[#A0A7B0] disabled:opacity-70 disabled:cursor-not-allowed" />
        </div>
      </div>

    </div>

    <!-- Inline footer (same as guest entry) -->
    <div class="bg-white border-t-[1.5px] border-[#EBEFF2] flex justify-end -mx-6 -mb-6 px-6 py-[14px] rounded-b-[10px]">
      <button type="button" (click)="onSubmit()" [disabled]="isSubmitting()"
        class="flex items-center gap-2 px-[17px] py-[6px] bg-[#238EC6] text-white text-base font-semibold border-0 rounded-[5px] cursor-pointer transition-colors hover:bg-[#1d7aad] disabled:opacity-60 disabled:cursor-not-allowed">
        {{ isSubmitting() ? (mode() === 'edit' ? 'Updating...' : 'Submitting...') : (mode() === 'edit' ? 'Update Request' : 'Create Request') }}
      </button>
    </div>
  </p-dialog>
}

<!-- ── Assign Popup ── -->
@if (showAssignPopup()) {
  <pa-assign-sp-popup
    [title]="assignPopupTitle()"
    [assignType]="assignPopupType()"
    (close)="onAssignSelected($event)"
  />
}

<!-- ── Coming Soon ── -->
@if (showComingSoon()) {
  <div class="fixed inset-0 flex items-center justify-center bg-black/40 z-[11000]">
    <div class="w-[380px] max-w-[95vw] rounded-[16px] bg-white shadow-[0_18px_45px_rgba(0,0,0,0.18)] p-10 flex flex-col items-center text-center">
      <h2 class="text-[#192A3E] font-bold text-[26px] mb-3">Coming Soon</h2>
      <p class="text-[#4E4D4D] text-base mb-6">This feature is coming soon. Stay tuned!</p>
      <button type="button" (click)="dismissComingSoon()"
        class="text-[#238EC6] text-lg font-semibold cursor-pointer bg-transparent border-0">
        OK
      </button>
    </div>
  </div>
}

<!-- ── Success Popup ── -->
@if (showSuccessPopup()) {
  <div class="fixed inset-0 flex items-center justify-center bg-black/40 z-[11000]">
    <div class="w-[482px] max-w-[95vw] border border-[#192A3E26] rounded-[16px] bg-white shadow-[0_18px_45px_rgba(0,0,0,0.15)] p-[50px_50px_70px_55px] flex flex-col text-left">
      <h2 class="text-[#192A3E] font-bold text-[32px] leading-8">{{ mode() === 'edit' ? 'Request Updated!' : 'Request Sent!' }}</h2>
      <div class="flex flex-col gap-6 border-t border-[#ebeff2] pt-[35px] mt-[44px] mb-10">
        <p class="text-[#4E4D4D] text-lg leading-6">Your front desk request has been successfully {{ mode() === 'edit' ? 'updated' : 'created' }}.</p>
        <p class="text-[#4E4D4D] text-lg leading-6">Please check your notifications for the latest updates and changes.</p>
        <p class="text-[#4E4D4D] text-lg leading-6">Thank you!</p>
      </div>
      <button type="button" class="text-[#192A3E] text-2xl leading-7 cursor-pointer font-medium bg-transparent border-0" (click)="onSuccessOk()">
        OK
      </button>
    </div>
  </div>
}
